/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-irregular-whitespace */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import {
  checkValidMobileNumber,
  DATE_MONTH_YEAR_VIEW_FORMAT,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  formatDate,
  formatTimeString,
  getNewDate,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import FlightEmailCard from '../one-way/FlightEmailCard';
import { getUserDetails } from '../../api/profileApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import { useAppContext } from '../../saas/AppConfigWrapper';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';

function OneWayWhatsAppModal({ searchRequest, selectedForEmail, onSend }) {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [showBreakup, setShowBreakup] = useState(true);
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');
  const [userDetails, setUserDetails] = useState(null);
  const [countryCode, setCountryCode] = useState('91');

  const getUserData = async () => {
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res?.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      setUserDetails(User);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return parseInt(val, 10) + markup;
  };

  const handlesendMessage = () => {
    if (
      whatsappNumber === '' ||
      whatsappNumber === undefined ||
      checkValidMobileNumber(whatsappNumber)
    ) {
      setValidationError(true);
      return false;
    }
    setIsLoading(true);
    const numberWithCountryCode = countryCode + whatsappNumber;
    setIsLoading(true);
    let fromEmail = '';
    let contactNum = '';
    // let companyName = '';
    if (!isEmpty(userDetails)) {
      fromEmail = userDetails.ContactEmail;
      contactNum = userDetails.ContactNumber;
      // companyName = userDetails.Company;
    }
    let msg = '';
    Object.keys(selectedForEmail).forEach((sec, secIndex) => {
      msg += `Trip - ${secIndex + 1}\n\n`;
      selectedForEmail[sec].forEach((flt, fltIndex) => {
        flt.flight.flightlegs.forEach((leg, index) => {
          msg += `${index === 0 ? index + 1 : ' '}${
            leg.validatingcarriername
          } ${leg.carrier.substring(0, 2)} - ${leg.flightnumber} | ${
            leg.origin_name
          } - ${formatDate(
            getNewDate(leg.depdate),
            DATE_MONTH_YEAR_VIEW_FORMAT,
          )} ${formatTimeString(leg.deptime)} --> ${
            leg.destination_name
          } - ${formatDate(
            getNewDate(leg.arrdate),
            DATE_MONTH_YEAR_VIEW_FORMAT,
          )} ${formatTimeString(leg.arrtime)} \n`;
        });
        msg += `Stops : ${
          flt.flight.numstops !== 0 ? flt.flight.numstops : 'Non'
        } Stop\n`;
        if (showBreakup) {
          msg += `${flt.fare.faretype} Fare : ${
            appConfig?.appCurrency
          } ${getAmount(flt.fare.totalfq)}/ ${
            flt.fare.refundableinfo === 'Y' ? 'Refundable' : 'Non-Refundable'
          }\n`;
        }
      });
    });
    msg += `\n\nThank you for choosing Fastays\nIn case of any urgent support : \n`;
    msg += `☎ Contact : ${contactNum}\n✉ Email  : ${fromEmail}\n`;
    onSend(numberWithCountryCode, msg);
  };

  const handleAddMarkup = (val) => {
    setMarkupToBeAdded(val);
  };

  return (
    <div>
      <AppLoading isLoading={isLoading} />
      <div>
        <div className="fs-14">
          <div className="d-flex align-items-center gap-3 mb-1">
            <AppRadioInput
              id="true"
              name="showBrakup"
              labelText="With Fare"
              value=""
              onChange={() => setShowBreakup(true)}
              checked={showBreakup}
            />
            <AppRadioInput
              id="false"
              name="showBrakup"
              labelText="Without Fare"
              value=""
              onChange={() => setShowBreakup(false)}
              checked={!showBreakup}
            />
          </div>
          <Row
            className="spacing-16 my-2"
            style={{ maxWidth: '716px', margin: '0 auto' }}
          >
            <Col lg={3} md={3} sm={6} xs={4}>
              <AppTextInput
                name="countryCode"
                label="Country Code"
                value={countryCode}
                type="text"
                maxLength={2}
                pattern="[0-9]{1,2}"
                onChange={(d) => setCountryCode(d.target.value)}
              />
            </Col>
            <Col lg={5} md={5} sm={6} xs={8}>
              <AppNumberInput
                name="whatsappNumber"
                label="Enter Mobile Number"
                placeholderText="Enter Customer No"
                value={whatsappNumber}
                required
                onChange={(d) => setWhatsappNumber(d)}
                errorText={validationError && 'Please Enter Mobile Number'}
              />
              {checkValidMobileNumber(whatsappNumber) && validationError && (
                <small className="app-error-text">Enter Valid Number</small>
              )}
            </Col>
            {getValueFromAppConfig('ISCORPORATECLIENT') !== 'true' && (
              <Col lg={4} md={4} sm={6} xs={12}>
                <AppNumberInput
                  name="markUpToBeAdded"
                  label="Markup"
                  value={markUpToBeAdded}
                  onChange={(d) => handleAddMarkup(d)}
                />
              </Col>
            )}
          </Row>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="overflow-auto"
            style={{
              maxHeight: '350px',
              maxWidth: '750px',
              overflowX: 'auto',
              overflowY: 'auto',
              padding: '1rem',
            }}
          >
            <div className="border" style={{ width: '700px' }}>
              {Object.keys(selectedForEmail).map((sec) => (
                <React.Fragment key={sec}>
                  <div
                    style={{
                      backgroundColor: '#fc790e',
                      color: '#fff',
                      fontSize: '14px',
                      fontWeight: '500',
                      padding: '5px 10px',
                    }}
                  >
                    {sec}
                  </div>
                  {selectedForEmail[sec].map((selectedFlight, index) => (
                    <FlightEmailCard
                      key={selectedFlight.fare.nextraflightkey}
                      flight={selectedFlight.flight}
                      isLast={index === selectedForEmail[sec].length - 1}
                      showHideFare={showBreakup}
                      fare={selectedFlight.fare}
                      searchRequest={searchRequest}
                      markUpToBeAdded={markUpToBeAdded}
                      index={index}
                      isOnward
                      showInput={showBreakup}
                      onFareUpdate={() => {}}
                    />
                  ))}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end my-2">
        <AppButton
          variant="primary"
          onClick={handlesendMessage}
          btnText="Share in Whatsapp"
        />
      </div>
    </div>
  );
}

OneWayWhatsAppModal.propTypes = {
  searchRequest: PropTypes.object.isRequired,
  selectedForEmail: PropTypes.array.isRequired,
  onSend: PropTypes.func.isRequired,
};

export default OneWayWhatsAppModal;
